import Request from "../../utils/Request";
import {AxiosResponse} from "axios";

/**
 * @request
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
const ForgotPasswordUpdatePassword = (data:any[] = false): Promise<AxiosResponse<any>> => {
	return Request.post(`/advisors/forgot-password/update-password`, data);
}
export default ForgotPasswordUpdatePassword;